<template>
  <div class="noIntroduction">
    <img :src="require('../assets/image/images/website_absent_280.png')">
    <span>网站不存在...</span>
    <span class="interval">{{distance}}秒后自动跳转</span>
  </div>
</template>
<script>
export default {
  name:'invalidPage',
  data(){
    return{
      distance:3
    }
  },
  mounted(){
    var _this = this;
    var countdownfunction = setInterval(function() {
      _this.distance --;
      if(_this.distance == 0){
        clearInterval(countdownfunction);
        location.href = 'https://520emv.com';
      }
    },1000)
  }
}
</script>
<style scoped>
.noIntroduction{
  height:100%;
  width:100%;
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
}
.noIntroduction span{
  color:#999;
  margin-top:12px;
  font-size:18px;
}
.noIntroduction .interval{
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/invalidPage.vue